import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=ec775ad4&scoped=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&id=ec775ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec775ad4",
  null
  
)

export default component.exports